"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceGenerationInvoices = class UcInvoiceGenerationInvoices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    sse = {
        cleanup: true,
    };
    beforeCreate() {
    }
    processMessage(...args) {
        const msg = args[0];
        if (msg.event === 'InvoiceGeneratorStatus') {
            this.$refs.panel.updateStatus(msg.data);
        }
        if (msg.event === 'InvoiceCreated') {
            this.$refs.grid.dataView.addItem(msg.data);
        }
        if (msg.event === 'InvoiceUpdated') {
            this.$refs.grid.dataView.updateItem(msg.data.id, msg.data);
        }
        if (msg.event === 'InvoiceDeleted') {
            this.$refs.grid.dataView.removeItem(msg.data.id);
        }
    }
    onIssueInvoicesPayload(...args) {
        return this.$imodal
            .show({ name: 'CompleteInvoicesAlt' })
            .then(result => {
            if (!result || result.cancel || !result.value) {
                return;
            }
            return this.selectedItems.map(p => ({
                ...result.value,
                invoice_id: p.id,
            }));
        });
    }
    getDownloadViewsPayload(...args) {
        return {
            identities: _.chain(this.selectedItems)
                .map(p => p.id)
                .uniq()
                .value()
        };
    }
    boundDownloadViewsPayloadMethod(...args) {
        if (!this._getDownloadViewsPayload) {
            this._getDownloadViewsPayload = this.getDownloadViewsPayload.bind(this);
        }
        return this._getDownloadViewsPayload;
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    gridName;
    resizeTrigger;
    selectedItems;
    ts;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_draft_invoices');
    }
    ux;
    b_1040167445267876_columnDefaults;
    b_1040167445267876_columns;
    dataMembers = ['gridName', 'resizeTrigger', 'selectedItems', 'ts', 'ds', 'ux', 'b_1040167445267876_columnDefaults', 'b_1040167445267876_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                gridName: "draftInvoices",
                resizeTrigger: 0,
                selectedItems: [],
                ts: null,
                ds: null,
                ux: null,
                b_1040167445267876_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_1040167445267876_columns: [{
                        field: "invoice",
                        name: this.$fn.pgettext("BillingList", "Invoice"),
                        params: {
                            sortPath: "invoice.invoice_number",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <a href=\"#\" onclick=\"return false;\">\n\
      <strong title=\"{{ $value.invoice_number }}\">{{ $value.invoice_number }}</strong>\n\
    </a>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                            ],
                        },
                    },
                    {
                        field: "company",
                        name: this.$fn.pgettext("BillingList", "Company"),
                        width: "100px",
                        params: {
                            sortPath: "company.code",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "company.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "partner",
                        name: this.$fn.pgettext("BillingList", "Partner"),
                        width: "100px",
                        params: {
                            sortPath: "partner.code",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "partner.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "rentals",
                        name: this.$fn.pgettext("InvoicesView", "Rentals"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "value",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "name",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "routeLink",
                                    to: "rental",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "contracts",
                        name: this.$fn.pgettext("InvoicesView", "Contracts"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "value",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "contract_number",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "routeLink",
                                    to: "contract",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        name: this.$fn.pgettext("Invoices", "Period start"),
                        params: {
                            sortPath: "billing_period.start",
                        },
                        field: "billing_period.start",
                        type: "date",
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "billing_period.start",
                                },
                            },
                        ],
                    },
                    {
                        name: this.$fn.pgettext("Invoices", "Period end"),
                        params: {
                            sortPath: "billing_period.end",
                        },
                        field: "billing_period.end",
                        type: "date",
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "billing_period.end",
                                },
                            },
                        ],
                    },
                    {
                        field: "billing_category",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Billing category"),
                    },
                    {
                        field: "net_amount",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Net"),
                        type: "number",
                        formatter: {
                            name: "number",
                        },
                    },
                    {
                        field: "vat_amount",
                        name: this.$fn.pgettext("InvoiceBrowserView", "VAT"),
                        type: "number",
                        formatter: {
                            name: "number",
                        },
                    },
                    {
                        field: "amount",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Amount"),
                        type: "number",
                        formatter: {
                            name: "number",
                        },
                    },
                    {
                        field: "currency",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Currency"),
                    },
                    {
                        field: "invoice_date",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Invoice date"),
                        type: "date",
                    },
                    {
                        field: "fulfillment_date",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Fulfillment date"),
                        type: "date",
                    },
                    {
                        field: "due_date",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Due date"),
                        type: "date",
                    },
                    {
                        field: "accounting_date",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Accounting date"),
                        type: "date",
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_1040167445267876_setData_7396_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1040167445267876_selectedRowsChanged(event, scope) {
        return await this.actions.evh_1040167445267876_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_showModal_7398_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                oid: $event.data.data.id,
                modal: true,
            },
        };
    }
    async evh_1040167445267876_command_7397_getWhen($event) {
        return $event.data.column.id === 'invoice';
    }
    async evh_1040167445267876_command(event, scope) {
        return await this.actions.evh_1040167445267876_command.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_reloadSlickgrid_7402_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_7789867021953041_close_7401_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_7789867021953041_showModal_7400_getActionArgs($event) {
        return {
            name: "BatchInvoiceEditor",
            props: {
                invoices: this.selectedItems,
            },
        };
    }
    async evh_7789867021953041_click(event, scope) {
        return await this.actions.evh_7789867021953041_click.executeFromDOM(this, event, scope);
    }
    async act_3468003412020058_reloadSlickgrid_7406_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async act_3468003412020058_request_7404_getActionArgs($event) {
        return {
            operation: "merge_invoices",
            data: {
                items: _.chain(this.selectedItems)
                    .filter(p => _.get(p, 'id') != null)
                    .map(p => p.id)
                    .uniq()
                    .value()
            },
        };
    }
    async evh_3468003412020058_click(event, scope) {
        return await this.actions.evh_3468003412020058_click.executeFromDOM(this, event, scope);
    }
    async act_4834182479726849_reloadSlickgrid_7410_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async act_4834182479726849_request_7408_getActionArgs($event) {
        return {
            operation: "delete_draft_invoices",
            data: {
                invoices: this.selectedItems.map(p => p.id)
            },
        };
    }
    async evh_4834182479726849_click(event, scope) {
        return await this.actions.evh_4834182479726849_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1040167445267876_setData_7396 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_7396_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_selectedRowsChanged_7395 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_7396,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_1040167445267876_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_selectedRowsChanged_7395],
        });
        const act_1040167445267876_showModal_7398 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1040167445267876_showModal_7398_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_command_7397 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_showModal_7398,
            event: "command",
            when: this.evh_1040167445267876_command_7397_getWhen,
            displayName: "showModal",
        });
        const evh_1040167445267876_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_command_7397],
        });
        const act_7789867021953041_reloadSlickgrid_7402 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_7789867021953041_reloadSlickgrid_7402_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_close_7401 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_reloadSlickgrid_7402,
            event: "close",
            when: this.evh_7789867021953041_close_7401_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_7789867021953041_showModal_7400 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7789867021953041_showModal_7400_getActionArgs,
            events: [evh_7789867021953041_close_7401],
        });
        const evh_7789867021953041_click_7399 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_showModal_7400,
            event: "click",
            displayName: "showModal",
        });
        const evh_7789867021953041_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_click_7399],
        });
        const act_3468003412020058_reloadSlickgrid_7406 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_3468003412020058_reloadSlickgrid_7406_getActionArgs,
            events: [],
        });
        const evh_3468003412020058_success_7405 = new core_1.actions.EventHandlerImpl({
            action: act_3468003412020058_reloadSlickgrid_7406,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_3468003412020058_request_7404 = new core_1.actions.RequestAction({
            actionArgs: this.act_3468003412020058_request_7404_getActionArgs,
            displayName: "mergeInvoices",
            events: [evh_3468003412020058_success_7405],
        });
        const evh_3468003412020058_click_7403 = new core_1.actions.EventHandlerImpl({
            action: act_3468003412020058_request_7404,
            event: "click",
            displayName: "mergeInvoices",
        });
        const evh_3468003412020058_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3468003412020058_click_7403],
        });
        const act_4834182479726849_reloadSlickgrid_7410 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4834182479726849_reloadSlickgrid_7410_getActionArgs,
            events: [],
        });
        const evh_4834182479726849_success_7409 = new core_1.actions.EventHandlerImpl({
            action: act_4834182479726849_reloadSlickgrid_7410,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_4834182479726849_request_7408 = new core_1.actions.RequestAction({
            actionArgs: this.act_4834182479726849_request_7408_getActionArgs,
            displayName: "deleteItems",
            events: [evh_4834182479726849_success_7409],
        });
        const evh_4834182479726849_click_7407 = new core_1.actions.EventHandlerImpl({
            action: act_4834182479726849_request_7408,
            event: "click",
            displayName: "deleteItems",
        });
        const evh_4834182479726849_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4834182479726849_click_7407],
        });
        return {
            act_1040167445267876_setData_7396,
            evh_1040167445267876_selectedRowsChanged_7395,
            evh_1040167445267876_selectedRowsChanged,
            act_1040167445267876_showModal_7398,
            evh_1040167445267876_command_7397,
            evh_1040167445267876_command,
            act_7789867021953041_reloadSlickgrid_7402,
            evh_7789867021953041_close_7401,
            act_7789867021953041_showModal_7400,
            evh_7789867021953041_click_7399,
            evh_7789867021953041_click,
            act_3468003412020058_reloadSlickgrid_7406,
            evh_3468003412020058_success_7405,
            act_3468003412020058_request_7404,
            evh_3468003412020058_click_7403,
            evh_3468003412020058_click,
            act_4834182479726849_reloadSlickgrid_7410,
            evh_4834182479726849_success_7409,
            act_4834182479726849_request_7408,
            evh_4834182479726849_click_7407,
            evh_4834182479726849_click,
            mergeInvoices: act_3468003412020058_request_7404,
            deleteItems: act_4834182479726849_request_7408,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], UcInvoiceGenerationInvoices.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceGenerationInvoices.prototype, "onSize", null);
UcInvoiceGenerationInvoices = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceGenerationInvoices);
exports.default = UcInvoiceGenerationInvoices;
vue_property_decorator_1.Vue.component("UcInvoiceGenerationInvoices", UcInvoiceGenerationInvoices);
